export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_TIMEZONES = 'SET_TIMEZONES';
